import React from "react"
import Link from "next/link"

import { getCategoryLinkByName } from "@/lib/link-utils/link-utils"
import { AccordionContent, AccordionItem, AccordionRoot, AccordionTrigger } from "@/components/ui/components"
import { StoryblokCategoriesProps } from "@/components/storyblok/header/StoryblokCategories"

export default function StoryblokMobileCategories({ blok, categories, sbLocale, loading }: StoryblokCategoriesProps) {
  if (loading) {
    return (
      <div className="flex flex-col gap-0.5">
        {Array.from({ length: 8 }).map((_, index) => (
          <div key={index} className="h-10 animate-pulse bg-gray-800" />
        ))}
      </div>
    )
  }

  return (
    <AccordionRoot type="single" collapsible>
      {categories.map((category) =>
        category.subCategories.length > 0 ? (
          <AccordionItem key={category.id} value={category.name}>
            <AccordionTrigger
              aria-label={"Categories"}
              className="bg-black pr-2 font-semibold text-white uppercase hover:bg-black"
            >
              <Link
                prefetch={false}
                href={getCategoryLinkByName(category.name, undefined, sbLocale)}
                className="flex h-full w-3/4 items-center pl-2 text-left"
              >
                {category.name}
              </Link>
            </AccordionTrigger>
            <AccordionContent className="py-2 pl-2">
              <StoryblokMobileCategories
                blok={blok}
                categories={category.subCategories}
                sbLocale={sbLocale}
              ></StoryblokMobileCategories>
            </AccordionContent>
          </AccordionItem>
        ) : (
          <Link
            prefetch={false}
            href={getCategoryLinkByName(category.name, undefined, sbLocale)}
            className="mb-0.5 flex bg-black py-1.5 pl-2 text-lg font-semibold text-white"
          >
            {category.name}
          </Link>
        )
      )}
    </AccordionRoot>
  )
}
